import { cn } from '@/src/infrastructure/lib/utils';
import type { FindingKind } from '../types';

const KIND_CONFIG: Record<string, { label: string; tone: string }> = {
  STUCK_PAYMENT: {
    label: 'Stuck Payment',
    tone: 'bg-indigo-500/10 text-indigo-400 border-indigo-500/30',
  },
  DOUBLE_CAPTURE: {
    label: 'Double Capture',
    tone: 'bg-rose-500/10 text-rose-400 border-rose-500/30',
  },
  DUPLICATE_CAPTURE: {
    label: 'Duplicate Capture',
    tone: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/30',
  },
  AMOUNT_DRIFT: {
    label: 'Amount Drift',
    tone: 'bg-amber-500/10 text-amber-400 border-amber-500/30',
  },
  STUCK_REFUND: {
    label: 'Stuck Refund',
    tone: 'bg-cyan-500/10 text-cyan-400 border-cyan-500/30',
  },
  ORPHANED_REFUND_REQUEST: {
    label: 'Orphan Refund',
    tone: 'bg-orange-500/10 text-orange-400 border-orange-500/30',
  },
  ORPHAN_GATEWAY_PAYMENT: {
    label: 'Orphan Gateway',
    tone: 'bg-purple-500/10 text-purple-400 border-purple-500/30',
  },
  OUT_OF_BAND_REFUND: {
    label: 'Dashboard Refund',
    tone: 'bg-teal-500/10 text-teal-400 border-teal-500/30',
  },
  SETTLEMENT_FEE_MISMATCH: {
    label: 'Fee Mismatch',
    tone: 'bg-yellow-500/10 text-yellow-400 border-yellow-500/30',
  },
  DISPUTED_PAYMENT: {
    label: 'Dispute / Chargeback',
    tone: 'bg-red-500/10 text-red-400 border-red-500/30',
  },
};

export function FindingKindBadge({ kind }: { kind: FindingKind }) {
  const config = KIND_CONFIG[kind] ?? {
    label: kind.replace(/_/g, ' '),
    tone: 'bg-slate-500/10 text-slate-400 border-slate-500/30',
  };

  return (
    <span
      data-testid="finding-kind-badge"
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border uppercase tracking-wider',
        config.tone,
      )}
    >
      {config.label}
    </span>
  );
}
